var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCookingTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.176,
    height: 25.177,
    viewBox: "0 0 25.176 25.177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cooking_time",
    "data-name": "Cooking time",
    transform: "translate(0.35 0.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1758",
    "data-name": "Path 1758",
    d: "M27.238,15A12.238,12.238,0,1,0,39.477,27.238,12.254,12.254,0,0,0,27.238,15Zm0,2.1A10.14,10.14,0,1,1,17.1,27.238,10.124,10.124,0,0,1,27.238,17.1Zm0,1.748A1.049,1.049,0,0,0,26.189,19.9v7.343a1.048,1.048,0,0,0,.306.743l4.7,4.7a1.051,1.051,0,1,0,1.486-1.486L28.287,26.8V19.9A1.049,1.049,0,0,0,27.238,18.846Z",
    transform: "translate(-15 -15)",
    fill: "#121e59",
    stroke: "#121e59",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingTime);
export default __webpack_public_path__ + "static/media/cookingTime.ea3d8e5b449db149be97c6a9960f230a.svg";
export { ForwardRef as ReactComponent };